import React, { useCallback } from "react";

// material-ui
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import SearchIcon from "@material-ui/icons/Search";

// styles
import { HeaderTextContainer, selectDateMenuStyles } from "./styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import Button from "components/CustomButtons/Button.js";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";

// components
import { BLUE_RGB } from "utils/colorsTheme";

const useStyles = makeStyles(selectDateMenuStyles);

const CardSelect = React.memo(
  ({
    isMulti = true,
    title = "Select 1",
    placeholder = "placeholder...",
    name = "select 1",
    data = [],
    value = null,
    onChange = () => {},
    onSubmit = () => {},
    disabled
  }) => {
    const classes = useStyles({ color: BLUE_RGB });

    const handleValues = useCallback(
      (values) => {
        onChange(values[name] ?? (isMulti ? [] : null));
      },
      [onChange, name, isMulti]
    );

    return (
      <React.Fragment>
        <GridContainer className={classes.grid}>
          <GridItem className={classes.gridNoPadding} xs={12} sm={12} md={12}>
            <Card className={classes.cardHover}>
              <CardHeader color="info" text>
                <CardText className={classes.cardHeader} color="info">
                  <HeaderTextContainer>
                    <SearchIcon />
                    <h5 className={classes.cardTitle}>Buscar</h5>
                  </HeaderTextContainer>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer
                  className={classes.marginRow}
                  justify="center"
                  alignItems="center"
                >
                  <GridItem xs={12} sm={10}>
                    <AutocompleteComponent
                      multiple={isMulti}
                      enableSelectAll={isMulti}
                      name={name}
                      search={name}
                      label={title}
                      placeholder={placeholder}
                      options={data}
                      value={value}
                      handleValues={handleValues}
                      disabled={disabled}
                      size="small"
                      limitTags={3}
                      textFieldProps={{ placeholder }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={2}>
                    <Button
                      onClick={onSubmit}
                      size="sm"
                      color="info"
                      fullWidth
                      disabled={disabled}
                    >
                      Buscar
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    );
  }
);

export default CardSelect;
